import { CompanyMapper } from "app/company/company.mapper";
import { Notification } from "./notification.model";
import { OrganizationMapper } from "app/organization/organization.mapper";

export class NotificationMapper {
  public static map(notificationData: any): Notification {
    if (!notificationData) {
      return null;
    }

    return new Notification(
      notificationData.id,
      notificationData.status,
      notificationData.title,
      notificationData.body,
      new Date(notificationData.createdAt),
      notificationData.highlighted,
      OrganizationMapper.map(notificationData.organization),
      notificationData.companies
        ? notificationData.companies.length > 0
          ? notificationData.companies.map(CompanyMapper.map)
          : []
        : [],
      notificationData.read,
    );
  }
}
